import React, { useEffect, useState } from 'react';
import type { IRouteComponentProps } from 'umi';
import { getLocale, useDispatch } from 'umi';
import {
  getLanguageFromUrl,
  getLocale2ComponentLocaleMap,
  transform2HantFormat,
} from '@/locales/lang';
import { LocaleProvider } from 'antd-mobile';
import { zhHant } from '@gov-mo/components/esm/locales/mobile';
import { updateLocale } from '@/utils/languageUtils';
import { getLoginUserInfo } from '@/services/UserApi';

export default function Layout({ children }: IRouteComponentProps) {
  const dispatch = useDispatch();
  const [locale, setLocale] = useState(() => transform2HantFormat(getLocale()));

  useEffect(() => {
    const language = getLanguageFromUrl();
    if (language) {
      updateLocale(language);
      if (language !== transform2HantFormat(getLocale())) {
        setLocale(language);
      }
    }
  }, []);

  useEffect(() => {
    getLoginUserInfo().then((res) => {
      dispatch({ type: 'user/update', profile: res.data });
    });
  }, []);

  const defaultAntdLocale = {
    ...(require('@gov-mo/components/esm/locales/mobile')[
      getLocale2ComponentLocaleMap[getLocale()]
    ] ?? zhHant),
  };

  return (
    <LocaleProvider key={locale} locale={defaultAntdLocale}>
      {children}
    </LocaleProvider>
  );
}
